export default __webpack_public_path__ + "static/media/0_0.241a6835.png";